import { RouteRecordRaw } from 'vue-router';
import { useCreativeStore, useAssetsStore, useTableStore, useCompanyStore } from '@/common/store';

const companyRoutes: RouteRecordRaw[] = [
  {
    path: 'companies',
    name: 'CompaniesView',
    redirect: { name: 'CompaniesListView' },
    meta: { menu: 'company' },
    component: () => import(/* webpackChunkName: "CompaniesView" */ '@/views/companies/CompaniesView.vue'),
    children: [
      {
        path: '',
        name: 'CompaniesListView',
        meta: { menu: 'default' },
        component: () => import(/* webpackChunkName: "CompaniesListView" */ '@/views/companies/CompaniesListView.vue'),
        beforeEnter: async () => {
          const assetsStore = useAssetsStore();
          const tableStore = useTableStore();
          const companyStore = useCompanyStore();
          const creativeStore = useCreativeStore();
          // Reset stores
          creativeStore.$reset();
          assetsStore.$reset();
          tableStore.$reset();
          // Reset current company
          companyStore.resetEditMode();
        },
      },
      {
        path: 'create',
        name: 'CompanyCreateView',
        component: () => import(/* webpackChunkName: "CompanyCreateView" */ '@/views/companies/CompanyEditView.vue'),
      },
      {
        path: ':id',
        name: 'CompanyDetailView',
        component: () => import(/* webpackChunkName: "CompanyDetailView" */ '@/views/companies/CompanyEditView.vue'),
      },
      {
        path: ':id/edit',
        name: 'CompanyEditView',
        component: () => import(/* webpackChunkName: "CompanyEditView" */ '@/views/companies/CompanyEditView.vue'),
      },
      {
        path: ':id/users',
        name: 'CompanyUsersView',
        component: () => import(/* webpackChunkName: "CompanyUsersView" */ '@/views/companies/CompanyUsersView.vue'),
      },
      {
        path: ':id/user-groups',
        name: 'CompanyUserGroupsView',
        component: () => import(/* webpackChunkName: "CompanyUserGroupsView" */ '@/views/companies/CompanyUserGroupsView.vue'),
      },
    ],
  },
];

export default companyRoutes;
